import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { personalLoanActions } from 'actions';
import { useRedux } from 'shared/hooks';
import { isUuid } from 'shared/utils';

const usePersonalLoan = (shouldFetch = true) => {
  const { uuid: appUuid } = useParams();
  let personalLoanUuid = appUuid;
  personalLoanUuid = isUuid(personalLoanUuid) ? personalLoanUuid : undefined;

  const { activeUuid, personalLoansByUuid, ...rest } = useRedux(
    'personalLoanReducer',
    personalLoanActions
  );
  const { getPersonalLoan } = rest;

  const personalLoan = personalLoansByUuid[personalLoanUuid || activeUuid] || {};

  useEffect(() => {
    if (personalLoanUuid && shouldFetch) {
      getPersonalLoan(personalLoanUuid);
    }
  }, [personalLoanUuid, getPersonalLoan, shouldFetch]);

  return {
    ...rest,
    personalLoansByUuid,
    personalLoan,
    uuid: personalLoanUuid,
  };
};

export default usePersonalLoan;
